"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Util = void 0;
/**
 * Static Utility Functions
 */
class Util {
    static canAugment() {
        return Util.canQuicklook() || Util.canSceneViewer();
    }
    static canQuicklook() {
        if (Util.isIOS()) {
            const isWKWebView = Boolean((window && window).webkit && window.webkit.messageHandlers);
            if (isWKWebView) {
                return Boolean(/CriOS\/|EdgiOS\/|FxiOS\/|GSA\/|DuckDuckGo\//.test(navigator.userAgent));
            }
            const tempAnchor = document.createElement("a");
            return tempAnchor.relList && tempAnchor.relList.supports && tempAnchor.relList.supports("ar");
        }
        return false;
    }
    static canSceneViewer() {
        return Util.isAndroid() && !Util.isFirefox() && !Util.isOculus();
    }
    static canRealityViewer() {
        return Util.isIOS() && Util.getIOSVersion()[0] >= 13;
    }
    static isSafariOnIOS() {
        return Util.isIOS() && Util.isSafari();
    }
    static isChromeOnIOS() {
        return Util.isIOS() && /CriOS\//.test(navigator.userAgent);
    }
    static isIOS() {
        return (/iPad|iPhone|iPod/.test(navigator.userAgent) && !self.MSStream) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
    }
    static isAndroid() {
        return /android/i.test(navigator.userAgent);
    }
    static isFirefox() {
        return /firefox/i.test(navigator.userAgent);
    }
    static isOculus() {
        return /OculusBrowser/.test(navigator.userAgent);
    }
    static isSafari() {
        return Util.isIOS() && /Safari\//.test(navigator.userAgent);
    }
    static getIOSVersion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            const v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (v !== null) {
                return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3], 10)];
            }
        }
        if (/Mac/.test(navigator.platform)) {
            const v = (navigator.appVersion).match(/Version\/(\d+)\.(\d+)\.?(\d+)?/);
            if (v !== null) {
                return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3], 10)];
            }
        }
        return [-1, -1, -1];
    }
    static getChromeVersion() {
        const raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        if (raw !== null) {
            return parseInt(raw[2], 10);
        }
        return 1;
    }
}
exports.Util = Util;
